import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ApiManagersKpiObjectiveMutateType } from "~/domains";

type RequestDataType = {
  kpiTermId: string;
  body: {
    title: string;
    unitName: string;
    objectivePerformance: number;
    displayOrder: number;
    employeeKpiObjectives: {
      employeeId: string;
      objectivePerformance: number;
    }[];
  };
};

const request = ({ kpiTermId, body }: RequestDataType) => {
  return new ApiClient()
    .post<ApiManagersKpiObjectiveMutateType>(
      `/api/managers/kpi_terms/${kpiTermId}/kpi_objectives`,
      {
        kpiObjective: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersKpiTermsKpiObjectivesCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersKpiObjectiveMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
